<template>
    <div class="findPwd">
       <forget-pwdTitle :active="1"></forget-pwdTitle>
        <div class="findPwd-page_main">
            <el-form class="findPwd-page_form"  label-width="80px" :model="ruleForm" ref="ruleForm">
                <send-code ref="getPhoneInfo" @submitRegForm="submitForm('userInfo')" :code-info="codeInfo"></send-code>
                <el-form-item class="findPwd-page_submit">
                    <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
                </el-form-item>
            </el-form>
            
        </div>

    </div>
</template>

<script>
import ForgetPwdTitle from "../../public/forgetPwdTitle";
import SendCode from "../../public/sendCode";
export default {
  name: "findPwdStep2",
  components: {
    forgetPwdTitle: ForgetPwdTitle,
    sendCode: SendCode
  },
  data() {
    return {
      ruleForm: {
        email: ""
      },
      codeInfo: {
        errorMsg: "",
        errorPhone: "",
        codeName: "forgetPwd"
      }
    };
  },
  methods: {
    submitForm() {
      const self = this;
      self.codeInfo.errorPhone = "";
      self.codeInfo.errorMsg = "";
      const phoneInfo = self.$refs.getPhoneInfo.phoneInfo;
      const phoneNo = phoneInfo.phone;
      const msgCode = phoneInfo.code;
      const xgh = localStorage.getItem("findPwdXGH");
      const token = localStorage.getItem("emailToken");
      if (!xgh || !token) {
        self.$alert("会话失效，请重新找回密码", "错误提示", {
          confirmButtonText: "确定",
          type: "error",
          center: true,
          customClass: "errMessage",
          callback: self.$router.push({ name: 'Step1'})
        });
      } else {
        self.$refs["getPhoneInfo"].validatePhone(valid => {
          if (valid) {
            const url =
              "/email/checkUser?xgh=" +
              xgh +
              "&phone=" +
              phoneNo +
              "&code=" +
              msgCode +
              "&token=" +
              self.md5(token);
            self.postRequest(url, {}).then(result => {
              console.log("验证手机", result.data);
              if (result.data && result.data.msgStatus == 1) {
                localStorage.setItem("emailToken", "");
                localStorage.setItem("findPwdToken", result.data.msgCode);
                localStorage.removeItem("phone");
                localStorage.setItem("phone", phoneNo);
                localStorage.removeItem("code");
                localStorage.setItem("code", msgCode);
                self.$router.push({ name: 'Step3'})
              } else if (result.data.msgStatus == 2) {
                self.codeInfo.errorPhone = "手机号码错误";
              } else if (result.data.msgStatus == 3) {
                self.codeInfo.errorMsg = "验证码错误";
              } else {
                self.$alert("会话失效，请重新找回密码", "错误提示", {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true,
                  customClass: "errMessage",
                  callback: self.$router.push({ name: 'Step1'})
                });
              }
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    }
  },
  mounted() {
    const self = this;
    const findPwdXGH = localStorage.getItem("findPwdXGH");
    const emailToken = localStorage.getItem("emailToken");
    if (!findPwdXGH || !emailToken) {
      self.$router.push({ name: 'Step1'})
      self.$alert("认证身份信息已过期，请重新验证", "错误提示", {
        confirmButtonText: "确定",
        type: "error",
        center: true,
        customClass: "errMessage",
        callback: action => {
          self.$router.push({ name: 'Step1'})
        }
      });
    }
  }
};
</script>

<style scoped>
.forgetPwd {
  width: 100%;
}
.emailAddr {
  width: 195px;
}
.emailName {
  display: inline-block;
  border: 1px solid #dcdfe6;
  width: 170px;
  text-align: center;
  margin-left: -12px;
  line-height: 38px;
}
.findPwd-page_main {
  width: 782px;
  margin: 0 auto;
  background: #fbfbfd;
  margin-top: 50px;
  padding: 50px 0;
}
.findPwd-page_form {
  width: 440px;
  margin: 0 auto;
}
.findPwd-page_submit {
  margin-top: 50px;
}
.findPwd-page_submit button {
  width: 130px;
  height: 40px;
  line-height: 40px;
  padding: 0;
  color: #fff;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/page/reSetPwd/step2.vue